import { useEffect } from 'react';
import usePrevious from './usePrevious';

export default (callback = () => {}, observedValues) => {
  const prevObservedValues = observedValues ? observedValues.map(value => usePrevious(value)) : null;

  useEffect(() => {
    callback(...prevObservedValues);
  }, observedValues);
};
